import { TeamPlan, TeamPlanUsageCapType } from "@alch/dx-entities";
import {
  DEFAULT_USAGE_CAP_METRIC,
  UsageCapMetric,
} from "@alch/dx-entities/usage";
import { trpc } from "@util/trpc/trpcClient";
import usePlanOverride from "./usePlanOverride";

export default function useActivePlan<T = TeamPlan>(
  metric: UsageCapMetric = DEFAULT_USAGE_CAP_METRIC,
  opts?: { select: (data: TeamPlan) => T },
) {
  const {
    tier: tierOverride,
    term: termOverride,
    usageCapType: usageCapTypeOverride,
  } = usePlanOverride();

  return trpc.billing.getCurrentTeamPlan.useQuery<TeamPlan, T>(
    { metric },
    {
      refetchOnWindowFocus: false,
      select: (plan: TeamPlan): T => {
        const planOverride: TeamPlan = {
          ...plan,
          tier: tierOverride ?? plan.tier,
          term: termOverride ?? plan.term,
          autoScale:
            usageCapTypeOverride != null
              ? usageCapTypeOverride === TeamPlanUsageCapType.AutoScale
              : plan.autoScale,
        };

        return opts?.select?.(planOverride) ?? (planOverride as T);
      },
    },
  );
}
